var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert',{attrs:{"type":"loader","color":"light"}})
}
var staticRenderFns = []

export { render, staticRenderFns }